import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { useRouter } from '@atlassian/react-resource-router';

const RedirectLegacyReportPage = (): React.JSX.Element => {
	const [{ query }] = useRouter();

	return <ScreenRedirect to={`/jira/plans/reports/${query.r}`} persistSearchParams={false} />;
};

export default RedirectLegacyReportPage;
